module.exports = __webpack_public_path__ + "static/media/chime.dc28d546.wav";